// The body of the delete-level confirmation, from getLevelDeletionSummary.
const LevelDeletionMessage = ({
  level,
  deleted,
}: {
  level: number;
  deleted: ReadonlyArray<string>;
}) => (
  <div className="flex flex-col gap-2">
    <p>
      This deletes level {level} from every career track
      {deleted.length > 0 ? ", along with:" : "."}
    </p>
    {deleted.length > 0 && (
      <ul className="list-disc pl-5 flex flex-col gap-1">
        {deleted.map((line) => (
          <li key={line}>{line}</li>
        ))}
      </ul>
    )}
    <p>Levels above it move down one. This can&apos;t be undone.</p>
  </div>
);

export default LevelDeletionMessage;
